export default __webpack_public_path__ + "static/media/mediaTypeTV.6a176071.svg";